/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createNewAccount = /* GraphQL */ `
  mutation CreateNewAccount {
    createNewAccount
  }
`;
export const inviteNewMember = /* GraphQL */ `
  mutation InviteNewMember($org_id: ID!, $email: String!, $name: String!) {
    inviteNewMember(org_id: $org_id, email: $email, name: $name)
  }
`;
export const inviteNewGuest = /* GraphQL */ `
  mutation InviteNewGuest($guestEmail: String!, $emailList: [String], $nameList: [String], $vaultId : ID!, $logo: String, $authType: String, $customMessage: String, $openTasks: [String], $fileNames: [String]) {
    inviteNewGuest(guestEmail : $guestEmail, emailList : $emailList, nameList : $nameList, vaultId: $vaultId, logo: $logo, authType: $authType, customMessage: $customMessage, openTasks: $openTasks, fileNames: $fileNames)
  }
`;

export const sendFeedback = /* GraphQL */ `
  mutation SendFeedback($name: String, $email : String, $message: String, $feedbackType : String) {
    sendFeedback(name : $name, email : $email, message : $message, feedbackType: $feedbackType)
  }
`;
export const setNewPassword = /* GraphQL */ `
  mutation SetNewPassword($newPassword: String!) {
    setNewPassword(newPassword : $newPassword)
  }
`;

export const updateGuestEmail = /* GraphQL */ `
  mutation UpdateGuestEmail($subject: String!, $header : String!, $body : String!, $replyToEmail: String) {
    updateGuestEmail(subject : $subject, header: $header, body: $body, replyToEmail : $replyToEmail)
  }
`;

export const updateEmailTemplates = /* GraphQL */ `
  mutation UpdateEmailTemplates(
    $guestInvite_subject: String,
    $guestInvite_header: String,
    $guestInvite_body: String,
    $memberInvite_subject: String,
    $memberInvite_body: String,
    $taskReminder_subject: String,
    $taskReminder_intro: String,
    $taskReminder_closing: String,
    $notification_subject: String,
    $notification_body: String,
    $magicLink_subject: String,
    $magicLink_body: String,
    $magicLink_expiry: String
  ) {
    updateEmailTemplates(
      guestInvite_subject: $guestInvite_subject,
      guestInvite_header: $guestInvite_header,
      guestInvite_body: $guestInvite_body,
      memberInvite_subject: $memberInvite_subject,
      memberInvite_body: $memberInvite_body,
      taskReminder_subject: $taskReminder_subject,
      taskReminder_intro: $taskReminder_intro,
      taskReminder_closing: $taskReminder_closing,
      notification_subject: $notification_subject,
      notification_body: $notification_body,
      magicLink_subject: $magicLink_subject,
      magicLink_body: $magicLink_body,
      magicLink_expiry: $magicLink_expiry
    )
  }
`;

export const disableMember = /* GraphQL */ `
  mutation DisableMember($memberId: String!) {
    disableMember(memberId: $memberId)
  }
`;
export const fileUploaded = /* GraphQL */ `
  mutation FileUploaded(
    $id: ID!
    $filename: String!
    $extension: String
    $size: Float
    $vault_id: ID
    $parent_folder_file_id: ID
    $org_id: ID
  ) {
    fileUploaded(
      id: $id
      filename: $filename
      extension: $extension
      size: $size
      vault_id: $vault_id
      parent_folder_file_id: $parent_folder_file_id
      org_id: $org_id
    ) {
        id
	    parent_folder_file_id
	    vault_id
	    org_id
	    name
	    extension
	    size
	    created_by
	    modified_on
	    modified_by
	    modified_by_name
        modified_by_email
	    comments {
	        comment
	        user_name
	        created_date
	        created_by
	        _lastChangedAt
	      }
	    _version
	    _deleted
	    _lastChangedAt
    }
  }
`;
export const saveVaultExternalEmail = /* GraphQL */ `
  mutation SaveVaultExternalEmail($vault_id: ID!, $org_id: ID!, $email: String!) {
    saveVaultExternalEmail(vault_id: $vault_id, org_id: $org_id, email: $email)
  }
`;
export const createVault = /* GraphQL */ `
  mutation CreateVault($name: String!, $org_id: String!, $tags: [String], $isTemplate: Boolean, $templateId: String) {
    createVault(name: $name, org_id: $org_id, tags: $tags, isTemplate: $isTemplate, templateId: $templateId) {
      id
      name
      org_id
      org_name
      initial_user_id
      external_email
      last_upload_at
      last_pdf_sign_at
      last_pdf_form_at
      last_comment_at
      last_download_at
      last_action
      users
      permissions {
        user_name
        user_email
        view_files
        upload_files
        rename_files
        delete_files
        upload_notification
        download_notification
        invitation_accepted
      }
      tags
      isTemplate
      createdAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteVault = /* GraphQL */ `
  mutation DeleteVault($vault_id: ID!) {
    deleteVault(vault_id: $vault_id)
  }
`;
export const updatePerms = /* GraphQL */ `
  mutation UpdatePerms($memberEmail: String!, $valueToChange: String!, $vaultId: ID, $newValue: String) {
    updatePerms(memberEmail : $memberEmail, valueToChange: $valueToChange, vaultId: $vaultId, newValue: $newValue)
  }
`;
export const savePdfForm = /* GraphQL */ `
  mutation savePdfForm(
    $vault_id: ID!
    $file_id: ID!
    $fdf_data: String
    $fdf_url: String
  ) {
    savePdfForm(
      vault_id: $vault_id
      file_id: $file_id
      fdf_data: $fdf_data
      fdf_url: $fdf_url
    )
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile(
    $file_id: [ID]!
    $vault_id: ID!
    $org_id: ID!
  ) {
    deleteFile(
      file_id: $file_id
      vault_id: $vault_id
      org_id: $org_id
    )
  }
`;
export const setUserToEmailVerified = /* GraphQL */ `
  mutation SetUserToEmailVerified {
    setUserToEmailVerified
  }
`;
export const vaultInvite = /* GraphQL */ `
  mutation VaultInvite($vaultId: ID!, $acceptInvite: Boolean!) {
    vaultInvite(vaultId: $vaultId, acceptInvite: $acceptInvite)
  }
`;
export const renameFile = /* GraphQL */ `
  mutation RenameFile(
    $isFolder: Boolean!
    $file_id: ID!
    $org_id: ID!
    $vault_id: ID!
    $name: String!
  ) {
    renameFile(
      isFolder: $isFolder
      file_id: $file_id
      org_id: $org_id
      vault_id: $vault_id
      name: $name
    )
  }
`;
export const updateFileComment = /* GraphQL */ `
  mutation UpdateFileComment(
    $file_id: ID!
    $org_id: ID!
    $vault_id: ID!
    $comment: String!
    $comment_id: ID
  ) {
    updateFileComment(
      file_id: $file_id
      org_id: $org_id
      vault_id: $vault_id
      comment: $comment
      comment_id: $comment_id
    )
  }
`;

export const updateFileSignatureStatus = /* GraphQL */ `
  mutation UpdateFileSignatureStatus(
    $file_id: ID!
    $org_id: ID!
    $vault_id: ID!
    $signature_status: String
    $signatures_outstanding: Int
    $signature_progress: AWSJSON
  ) {
    updateFileSignatureStatus(
      file_id: $file_id
      org_id: $org_id
      vault_id: $vault_id
      signature_status: $signature_status
      signatures_outstanding: $signatures_outstanding
      signature_progress: $signature_progress
    )
  }
`;

export const updateVaultSettings = /* GraphQL */ `
  mutation UpdateVaultSettings(
    $org_id: ID!
    $vault_id: ID!
    $name: String
    $private_mode: Boolean
    $hide_perms: Boolean
    $restricted_upload_path: String
    $tags: [String]
    $archived: Boolean
    $isTemplate: Boolean
    $workflowStateId: Int
    $workflowStateName: String
    $workflowId: ID
    $currentWorkflowStateId: Int
    $externalSystemIds: AWSJSON
  ) {
    updateVaultSettings(
      org_id: $org_id
      vault_id: $vault_id
      name: $name
      private_mode: $private_mode
      hide_perms: $hide_perms
      restricted_upload_path: $restricted_upload_path
      tags: $tags
      archived: $archived
      isTemplate: $isTemplate
      workflowStateId: $workflowStateId
      workflowStateName: $workflowStateName
      workflowId: $workflowId
      currentWorkflowStateId: $currentWorkflowStateId
      externalSystemIds: $externalSystemIds
    )
  }
`;
export const moveFile = /* GraphQL */ `
  mutation MoveFile(
    $file_id: [ID]!
    $overwrite_id: [ID]!
    $org_id: ID!
    $vault_id: ID!
    $destination: String
    $copy: Boolean
  ) {
    moveFile(
      file_id: $file_id
      overwrite_id: $overwrite_id
      org_id: $org_id
      vault_id: $vault_id
      destination: $destination
      copy: $copy
    )
  }
`;
export const updateCompanyName = /* GraphQL */ `
  mutation UpdateCompanyName(
    $company_name: String
  ) {
    updateCompanyName(
      company_name: $company_name
    )
  }
`;
export const updateOrganizationBoolean = /* GraphQL */ `
  mutation UpdateOrganizationBoolean(
    $field: String
    $value: Boolean
    $terms: String
  ) {
    updateOrganizationBoolean(
      field: $field
      value: $value
      terms: $terms
    )
  }
`;
export const updateWorkflowStates = /* GraphQL */ `
  mutation UpdateWorkflowStates(
    $workflowStatesEnabled: Boolean
    $workflowStates: String
  ) {
    updateWorkflowStates(
      workflowStatesEnabled: $workflowStatesEnabled
      workflowStates: $workflowStates
    )
  }
`;
export const updateBrandingSettings = /* GraphQL */ `
  mutation UpdateBrandingSettings(
    $hideZapaLogo: Boolean
    $primaryBrandColor: String
    $primaryBrandColorName: String
  ) {
    updateBrandingSettings(
      hideZapaLogo: $hideZapaLogo
      primaryBrandColor: $primaryBrandColor
      primaryBrandColorName: $primaryBrandColorName
    )
  }
`;
export const setVaultAsFavorite = /* GraphQL */ `
  mutation SetVaultAsFavorite(
    $vault_id: ID
    $remove_vault: Boolean
  ) {
    setVaultAsFavorite(
      vault_id: $vault_id
      remove_vault: $remove_vault
    )
  }
`;
export const setVaultAsTermsAccepted = /* GraphQL */ `
  mutation SetVaultAsTermsAccepted(
    $vault_id: ID
    $remove_vault: Boolean
  ) {
    setVaultAsTermsAccepted(
      vault_id: $vault_id
      remove_vault: $remove_vault
    )
  }
`;
export const convertGuestAccount = /* GraphQL */ `
  mutation ConvertGuestAccount(
    $newOrgName: String
  ) {
    convertGuestAccount(
      newOrgName: $newOrgName
    )
  }
`;
export const uploadLogo = /* GraphQL */ `
  mutation UploadLogo(
    $filename: String
    $data: String
  ) {
    uploadLogo(
      filename: $filename
      data: $data
    )
  }
`;
export const newAuditNotificationAction = /* GraphQL */ `
  mutation NewAuditNotificationAction(
      $action: String
      $action_date: String
      $file_id: ID
      $filename: String
      $description: String
      $vault_id: ID
      $org_id: ID
  ) {
    newAuditNotificationAction(
      action: $action
      action_date: $action_date
      file_id: $file_id
      filename: $filename
      description: $description
      vault_id: $vault_id
      org_id: $org_id
    )
  }
`;

export const reminders = /* GraphQL */ `
  mutation Reminders(
    $taskIds: [ID]
    $vault_id: ID
    $org_id: ID
    $due_date: String
  ) {
    reminders(
      taskIds: $taskIds
      vault_id: $vault_id
      org_id: $org_id
      due_date: $due_date
    )
  }
`;
export const createStripe = /* GraphQL */ `
  mutation CreateStripe($newOrganizationTier: String, $stripeDiscount: Boolean, $stripeCustomerId : String) {
    createStripe(newOrganizationTier: $newOrganizationTier, stripeDiscount: $stripeDiscount, stripeCustomerId: $stripeCustomerId)
  }
`;
export const updateStripe = /* GraphQL */ `
  mutation UpdateStripe(
    $orgId : ID
    $subscriptionId: String
    $newTier: String
    $cancelStripe: Boolean
    $calcProration: Boolean
    $stripeCustomerId: String
    $stripeDiscount : Boolean
  ) {
    updateStripe(
      orgId: $orgId
      subscriptionId: $subscriptionId
      newTier: $newTier
      cancelStripe: $cancelStripe
      calcProration: $calcProration
      stripeCustomerId: $stripeCustomerId
      stripeDiscount : $stripeDiscount
    )
  }
`;
export const markFilesAsRead = /* GraphQL */ `
  mutation MarkFilesAsRead(
    $fileIds: [ID]
    $org_id: ID
    $vault_id: ID
  ) {
    markFilesAsRead(
      fileIds: $fileIds
        vault_id: $vault_id
        org_id: $org_id
    )
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask(
    $vault_id: ID
    $task_id: ID
    $num_tasks_closed: Int
    $num_tasks_open: Int
    $earliest_open_task_date: String
  ) {
    deleteTask(
      vault_id: $vault_id
      task_id: $task_id
      num_tasks_closed: $num_tasks_closed
      num_tasks_open: $num_tasks_open
      earliest_open_task_date: $earliest_open_task_date
    )
  }
`;

export const updateTask = /* GraphQL */ `
  mutation UpdateTask(
    $id: ID
    $vault_id: ID
    $org_id: ID
    $attached_files: [ID]
    $action_type: String
    $title: String
    $description: String
    $status: String
    $due_date: String
    $send_reminder: Boolean
    $clientResponse: String
    $assigned_guest_ids: [ID]
    $assigned_guest_names: [String]
    $assigned_member_ids: [ID]
    $assigned_member_names: [String]
    $num_tasks_closed: Int
    $num_tasks_open: Int
    $earliest_open_task_date: String
  ) {
    updateTask(
      id: $id
      vault_id: $vault_id
      org_id: $org_id
      attached_files: $attached_files
      action_type: $action_type
      title: $title
      description: $description
      status: $status
      due_date: $due_date
      send_reminder: $send_reminder
      clientResponse: $clientResponse
      assigned_guest_ids: $assigned_guest_ids
      assigned_guest_names: $assigned_guest_names
      assigned_member_ids: $assigned_member_ids
      assigned_member_names: $assigned_member_names
      num_tasks_closed: $num_tasks_closed
      num_tasks_open: $num_tasks_open
      earliest_open_task_date: $earliest_open_task_date
    )
  }
`;

export const updateVaultForTier = /* GraphQL */ `
    mutation UpdateVaultForTier {
      updateVaultForTier
}
`;


  export const assignTasks = /* GraphQL */ `
  mutation AssignTasks(
    $vault_id: ID
    $task_id: ID
    $assigned_guest_ids: [ID]
    $assigned_guest_names: [String]
    $assigned_member_ids: [ID]
    $assigned_member_names: [String]
  ) {
    assignTasks(
      vault_id: $vault_id
      task_id: $task_id
      assigned_guest_ids: $assigned_guest_ids
      assigned_guest_names: $assigned_guest_names
      assigned_member_ids: $assigned_member_ids
      assigned_member_names: $assigned_member_names
    )
  }
`;

export const updateTaskComment = /* GraphQL */ `
  mutation UpdateTaskComment(
    $vault_id: ID
    $task_id: ID
    $task_comment_id: ID
    $comment: String
  ) {
    updateTaskComment(
      vault_id: $vault_id
      task_id: $task_id
      task_comment_id: $task_comment_id
      comment: $comment
    )
  }
`;

export const markTaskAsDone = /* GraphQL */ `
  mutation MarkTaskAsDone(
    $vault_id: ID
    $task_id: ID
    $status: String
    $num_tasks_closed: Int
    $num_tasks_open: Int
    $earliest_open_task_date: String
  ) {
    markTaskAsDone(
      vault_id: $vault_id
      task_id: $task_id
      status: $status
      num_tasks_closed: $num_tasks_closed
      num_tasks_open: $num_tasks_open
      earliest_open_task_date: $earliest_open_task_date
    )
  }
`;

export const addTask = /* GraphQL */ `
  mutation AddTask(
      $vault_id: ID
      $org_id: ID
      $attached_files: [ID]
      $action_type: String
      $clientResponse: String
      $title: String
      $description: String
      $status: String
      $due_date: String
      $send_reminder: Boolean
      $assigned_guest_ids: [ID]
      $assigned_guest_names: [String]
      $assigned_member_ids: [ID]
      $assigned_member_names: [String]
      $num_tasks_closed: Int
      $num_tasks_open: Int
      $earliest_open_task_date: String
  ) {
    addTask(
      vault_id: $vault_id
      org_id: $org_id
      attached_files: $attached_files
      action_type: $action_type
      clientResponse: $clientResponse
      title: $title
      description: $description
      status: $status
      due_date: $due_date
      send_reminder: $send_reminder
      assigned_guest_ids: $assigned_guest_ids
      assigned_guest_names: $assigned_guest_names
      assigned_member_ids: $assigned_member_ids
      assigned_member_names: $assigned_member_names
      num_tasks_closed: $num_tasks_closed
      num_tasks_open: $num_tasks_open
      earliest_open_task_date: $earliest_open_task_date
    )
  }
`;

export const addTaskComment = /* GraphQL */ `
  mutation AddTaskComment(
    $vault_id: ID
    $task_id: ID
    $comment_id: ID
    $comment: String
  ) {
    addTaskComment(
      vault_id: $vault_id
      task_id: $task_id
      comment_id: $comment_id
      comment: $comment
    )
  }
`;

export const deleteTaskComment = /* GraphQL */ `
  mutation DeleteTaskComment(
    $vault_id: ID
    $task_id: ID
    $comment_id: ID
  ) {
    deleteTaskComment(
      vault_id: $vault_id
      task_id: $task_id
      comment_id: $comment_id
    )
  }
`;

export const attachFileToTaskComment = /* GraphQL */ `
  mutation AttachFileToTaskComment(
    $vault_id: ID
    $task_id: ID
    $file_id: ID
  ) {
    attachFileToTaskComment(
      vault_id: $vault_id
      task_id: $task_id
      file_id: $file_id
    )
  }
`;

export const removeFileFromTaskComment = /* GraphQL */ `
  mutation RemoveFileFromTaskComment(
    $vault_id: ID
    $task_id: ID
    $file_id: ID
  ) {
    removeFileFromTaskComment(
      vault_id: $vault_id
      task_id: $task_id
      file_id: $file_id
    )
  }
`;

export const updateVaultPresence = /* GraphQL */ `
  mutation UpdateVaultPresence(
    $vault_id: ID!
    $session_id: ID!
    $status: String!
  ) {
    updateVaultPresence(
      vault_id: $vault_id
      session_id: $session_id
      status: $status
    ) {
      vault_id
      session_id
      user_id
      user_name
      status
      last_heartbeat
    }
  }
`;

export const sendWebRTCSignal = /* GraphQL */ `
  mutation SendWebRTCSignal(
    $vault_id: ID!
    $to_user_id: ID!
    $signal_type: String!
    $signal_data: String!
  ) {
    sendWebRTCSignal(
      vault_id: $vault_id
      to_user_id: $to_user_id
      signal_type: $signal_type
      signal_data: $signal_data
    ) {
      vault_id
      from_user_id
      from_user_name
      to_user_id
      signal_type
      signal_data
      timestamp
    }
  }
`;

export const startCall = /* GraphQL */ `
  mutation StartCall(
    $vault_id: ID!
  ) {
    startCall(
      vault_id: $vault_id
    )
  }
`;

export const endCall = /* GraphQL */ `
  mutation EndCall(
    $vault_id: ID!
    $call_id: ID!
  ) {
    endCall(
      vault_id: $vault_id
      call_id: $call_id
    )
  }
`;

export const sendSignatureRequest = /* GraphQL */ `
  mutation SendSignatureRequest(
    $email: String
    $recipients: [SignatureRecipientInput]
    $portal_id: ID
    $portal_name: String
    $file_id: ID
    $file_data: String
    $file_name: String
    $field_assignments: AWSJSON
    $required_fields_xfdf: String
    $custom_message: String
  ) {
    sendSignatureRequest(
      email: $email
      recipients: $recipients
      portal_id: $portal_id
      portal_name: $portal_name
      file_id: $file_id
      file_data: $file_data
      file_name: $file_name
      field_assignments: $field_assignments
      required_fields_xfdf: $required_fields_xfdf
      custom_message: $custom_message
    )
  }
`;

export const completeSignature = /* GraphQL */ `
  mutation CompleteSignature(
    $signature_request_id: ID!
    $completed_xfdf: String!
    $token: String!
  ) {
    completeSignature(
      signature_request_id: $signature_request_id
      completed_xfdf: $completed_xfdf
      token: $token
    )
  }
`;

export const cancelSignatureRequest = /* GraphQL */ `
  mutation CancelSignatureRequest($signature_request_id: ID!) {
    cancelSignatureRequest(signature_request_id: $signature_request_id)
  }
`;

export const deleteSignatureRequest = /* GraphQL */ `
  mutation DeleteSignatureRequest($signature_request_id: ID!) {
    deleteSignatureRequest(signature_request_id: $signature_request_id)
  }
`;

export const resendSignatureRequest = /* GraphQL */ `
  mutation ResendSignatureRequest($signature_request_id: ID!, $recipient_email: String) {
    resendSignatureRequest(signature_request_id: $signature_request_id, recipient_email: $recipient_email)
  }
`;

export const updatePublicOrganization = /* GraphQL */ `
  mutation UpdatePublicOrganization(
    $subdomain: String
    $logo_s3_path: String
    $primaryBrandColor: String
    $hideZapaLogo: Boolean
  ) {
    updatePublicOrganization(
      subdomain: $subdomain
      logo_s3_path: $logo_s3_path
      primaryBrandColor: $primaryBrandColor
      hideZapaLogo: $hideZapaLogo
    )
  }
`;

export const setupUserMfa = /* GraphQL */ `
  mutation SetupUserMfa(
    $mfaMethod: String!
    $phoneNumber: String
    $accessToken: String
  ) {
    setupUserMfa(
      mfaMethod: $mfaMethod
      phoneNumber: $phoneNumber
      accessToken: $accessToken
    ) {
      success
      message
      session
    }
  }
`;

export const verifyMfaSetup = /* GraphQL */ `
  mutation VerifyMfaSetup(
    $code: String!
    $session: String
    $mfaMethod: String!
    $accessToken: String!
  ) {
    verifyMfaSetup(
      code: $code
      session: $session
      mfaMethod: $mfaMethod
      accessToken: $accessToken
    ) {
      success
      message
    }
  }
`;

export const updateUserMfaStatus = /* GraphQL */ `
  mutation UpdateUserMfaStatus($mfaSetupCompleted: Boolean!) {
    updateUserMfaStatus(mfaSetupCompleted: $mfaSetupCompleted) {
      id
      mfaSetupCompleted
      mfaEnforcementDate
    }
  }
`;

export const createOAuthClient = /* GraphQL */ `
  mutation CreateOAuthClient($name: String!, $redirect_uris: [String]!, $allowed_scopes: [String]!) {
    createOAuthClient(name: $name, redirect_uris: $redirect_uris, allowed_scopes: $allowed_scopes) {
      client_id
      client_secret
      org_id
      name
      redirect_uris
      allowed_scopes
      created_at
      created_by
    }
  }
`;

export const deleteOAuthClient = /* GraphQL */ `
  mutation DeleteOAuthClient($client_id: ID!) {
    deleteOAuthClient(client_id: $client_id)
  }
`;

export const createWebhook = /* GraphQL */ `
  mutation CreateWebhook($url: String!, $events: [String]!) {
    createWebhook(url: $url, events: $events) {
      org_id
      webhook_id
      url
      events
      secret
      enabled
      created_at
      created_by
    }
  }
`;

export const updateWebhook = /* GraphQL */ `
  mutation UpdateWebhook($webhook_id: ID!, $url: String, $events: [String], $enabled: Boolean) {
    updateWebhook(webhook_id: $webhook_id, url: $url, events: $events, enabled: $enabled)
  }
`;

export const deleteWebhook = /* GraphQL */ `
  mutation DeleteWebhook($webhook_id: ID!) {
    deleteWebhook(webhook_id: $webhook_id)
  }
`;

export const testWebhook = /* GraphQL */ `
  mutation TestWebhook($webhook_id: ID!) {
    testWebhook(webhook_id: $webhook_id)
  }
`;

export const createWorkflow = /* GraphQL */ `
  mutation CreateWorkflow(
    $name: String!
    $description: String
    $states: String
  ) {
    createWorkflow(
      name: $name
      description: $description
      states: $states
    ) {
      id
      org_id
      name
      description
      states {
        id
        name
      }
      is_default
      created_at
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const updateWorkflow = /* GraphQL */ `
  mutation UpdateWorkflow(
    $id: ID!
    $name: String
    $description: String
    $states: String
  ) {
    updateWorkflow(
      id: $id
      name: $name
      description: $description
      states: $states
    ) {
      id
      org_id
      name
      description
      states {
        id
        name
      }
      is_default
      created_at
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const deleteWorkflow = /* GraphQL */ `
  mutation DeleteWorkflow($id: ID!) {
    deleteWorkflow(id: $id)
  }
`;

export const updateExternalSystems = /* GraphQL */ `
  mutation UpdateExternalSystems($external_systems: [String]!) {
    updateExternalSystems(external_systems: $external_systems)
  }
`;